import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper } from '@mui/material';
import InvoiceConfigTable from '../components';
import { globalGetService, globalPutService } from '../../../../utils/globalApiServices';
import { getInvoiceTitleListApi, updateInvoiceTitleApi } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { NoRecordFound, PageLoader, STableLoader } from '../../../../shared_elements';
import { trackActivity } from '../../../../utils/mixpanel';
import SettingPageLayout from '../../../elements/SettingPageLayout';
import { RoleBaseAccess } from '../../../../hoc';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';


const InvoiceConfiguration = () => {
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [invoiceTitles, setInvoiceTitles] = useState([]);
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });



    useEffect(() => {
        getInvoiceTitleList('skeletonLoader');
        trackActivity('Page Viewed',{ page_title: 'Invoice Title Configuration'})
    }, [])

    const getInvoiceTitleList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getInvoiceTitleListApi(query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setInvoiceTitles(response?.data?.data?.list || []);
            }
        })
    }
    const updateInvoiceTitle = (title, invoiceType) => {
        setLoading(true);
        const payload = {
            user_defined_title: title
        }
        globalPutService(updateInvoiceTitleApi(invoiceType), payload).then(response => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                trackActivity('Item Edited', { page_title: `Edit Invoice Title Configuration`, success_msg: response?.data?.message, payload, response: response?.data })
                setLoading(false);
                getInvoiceTitleList();
            }
            else{
                enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
                trackActivity('Item Edited', { page_title: `Edit Invoice Title Configuration`, error_msg: response?.data?.message, payload, response: response?.data })
                getInvoiceTitleList();
            }
        })
    }
    return (
        <SettingPageLayout>
            <div className="lease-detail-table">
                {skeletonLoader ? <STableLoader count={4} rowCount={13} /> : (<>
                    <Paper sx={{ px: 2, pt: 2, pb: 1, boxShadow: '0px 0px 2px 1px #BBBBBB' }} elevation={0}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5, fontSize: '18px' }} color='primary'> Invoice Title </Typography>
                            <ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: "", type: "global" } })} />
                        </div>
                        <div className="settings-inv-config-container">
                            <Table className="mui-table-format" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ minWidth: 160, padding: '10px !important' }}>
                                            Invoice Type
                                        </TableCell>
                                        <TableCell sx={{ minWidth: 200, padding: '10px !important' }}>
                                            Default Title
                                        </TableCell>
                                        <TableCell sx={{ minWidth: 220, padding: '10px !important' }}>
                                            Custom Title
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoiceTitles?.length > 0 && invoiceTitles.map((item, index) => (
                                        <InvoiceConfigTable key={index} item={item} onEditSave={updateInvoiceTitle} viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })} />
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                        {!skeletonLoader && invoiceTitles?.length === 0 && <NoRecordFound />}
                    </Paper>
                </>)}
            </div>
              { revisionHistory.modal &&
              <RevisionHistory
               moduleName={"invoice_configuration"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
              />
            }
            {isLoading ? <PageLoader /> : null}
        </SettingPageLayout>
    );
};

export default RoleBaseAccess(InvoiceConfiguration, { application: 'lease_revamp', feature: 'invoices', operationType: ['R'], settingNav: true });
